import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function About() {
  return (
    <PanelContent
      id="about_pannel"
      route="/about"
      title="Transpolis"
      subtitle="Centre d'essais pour l'innovation et la sécurité"
      description="Bienvenue sur la plateforme Transpolis. Situé à 45 km de Lyon, ce site de 80 hectares est dédié aux essais dans le domaine de la ville et de la mobilité intelligente et décarbonée. Dans le cadre du projet eRoadMontBlanc, il offre un environnement contrôlé pour évaluer le Système de Route Électrique (ERS) via un démonstrateur de 420 mètres, indispensable avant un déploiement sur route ouverte."
      prev=""
      next="/energyflow"
      txtbtn="ÉTAPE SUIVANTE"
    />
  );
}
